<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>▣ 메뉴설정</div>
            </strong>
          </div>
          <report-menu-component
            @setMenuCode="setMenuCode"
            :reportmenu="reportmenu"
            v-if="reportmenu.dr_type_code !== '' && formtype === 'update'"
          />
          <report-menu-component
            @setMenuCode="setMenuCode"
            v-if="formtype === 'insert'"
          />
        </b-card>
      </b-col>
      <b-col md="12">
        <!-- 기본 정보   -->
        <b-card>
          <div slot="header">
            <strong>▣ 기본 정보</strong>
          </div>
          <div class="table-responsive-sm">
            <table id="__BVID__2714" aria-busy="false" aria-colcount="4" aria-rowcount="-1" class="table b-table table-striped">
                <tbody class="">
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1; font-weight:bold">
                    <label class="col-form-label">보고서명 *</label>
                  </td>
                  <td class="" colspan="4">
                    <b-row class="pt-sm-12">
                      <b-col sm="12">
                        <b-form-input id="reportName"
                                      name="report_name"
                                      type="text"
                                      v-model="queryParams.report_name"
                                      v-validate="'required'"
                                      :class="{'is-invalid': errors.has('report_name')}"
                        />
                        </b-form-input>
                        <span v-show="errors.has('report_name')" :class="{error: errors.has('report_name')}">보고서명은 필수 항목 입니다.</span>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">부제목</label>
                  </td>
                  <td class="" colspan="4">
                    <b-row class="pt-sm-12">
                      <b-col sm="12">
                        <b-form-input id="subReportName" name="sub_report_name" type="text" v-model="queryParams.sub_report_name"></b-form-input>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">저자</label>
                  </td>
                  <td class="" colspan="4">
                    <b-row class="pt-sm-12">
                      <b-col sm="12">
                        <b-form-input id="author" name="author" type="text" v-model="queryParams.author"></b-form-input>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1; font-weight:bold">
                        <label class="col-form-label">판매구분 *</label>
                      </td>
                      <td class="" style="text-align: left;">
                        <label class="col-form-label">
                          <b-form-radio-group
                            v-model="queryParams.sales_type"
                            @change="changeSalesType()"
                          >
                            <b-form-radio value="free" :disabled="formtype==='update'">무료</b-form-radio>
                            <b-form-radio value="pay" :disabled="formtype==='update'">유료</b-form-radio>
                          </b-form-radio-group>
                        </label>
                      </td>
<!--                      <td width="150" style="background-color:#f1f1f1; font-weight:bold">-->
<!--                        <label class="col-form-label">미리보기 사용 *</label>-->
<!--                      </td>-->
<!--                      <td class="" style="text-align: left;">-->
<!--                        <label class="col-form-label">-->
<!--                          <b-form-radio-group v-model="queryParams.preview_yn" @change="changePreviewYn()">-->
<!--                            <b-form-radio value="Y">사용</b-form-radio>-->
<!--                            <b-form-radio value="N">사용 안함</b-form-radio>-->
<!--                          </b-form-radio-group>-->
<!--                        </label>-->
<!--                      </td>-->
                  </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1; font-weight:bold">
                    <label class="col-form-label">노출여부 *</label>
                  </td>
                  <td class="" style="text-align: left;">
                    <label class="col-form-label">
                      <b-form-radio-group v-model="queryParams.view_yn">
                        <b-form-radio value="Y">노출</b-form-radio>
                        <b-form-radio value="N">비노출</b-form-radio>
                      </b-form-radio-group>
                    </label>
                  </td>
                  <td width="150" style="background-color:#f1f1f1; font-weight:bold">
                    <label class="col-form-label">인기리포트 *</label>
                  </td>
                  <td class="">
                    <b-form-radio-group v-model="queryParams.bestview_yn">
                      <b-form-radio value="Y">사용</b-form-radio>
                      <b-form-radio value="N">사용 안함</b-form-radio>
                    </b-form-radio-group>
                  </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">출시일 설정</label>
                  </td>
                  <td class="">
                    <b-row class="pt-sm-12">
                      <b-col sm="5"><b-form-input type="text" v-model="queryParams.custom_date" name="daterange" /></b-col>
                    </b-row>
                  </td>

                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">표본수</label>
                  </td>
                  <td class="">
                    <b-row class="pt-sm-12">
                      <b-col sm="5"><b-form-input type="text" v-model="queryParams.sample_comment"/></b-col>
                    </b-row>
                  </td>
                </tr>
                <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                  <td width="150" style="background-color:#f1f1f1">
                    <label class="col-form-label">ISBN</label>
                  </td>
                  <td class="">
                    <b-col sm="10"><b-form-input type="text" v-model="queryParams.ibsn"/></b-col>
                  </td>

                  <td width="150" style="background-color:#f1f1f1">

                  </td>
                  <td class="">
                    <b-row class="pt-sm-12">

                    </b-row>
                  </td>
                </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">
                          썸네일 이미지
                          <br/>
                          (730 x 410)
                        </label>
                      </td>
                      <td class="" colspan="4">
                        <b-row class="pt-sm-12">
                          <b-col sm="10">
                            <div style="border:1px solid #c2cfd6; border-radius:4px">
                              <input type="file"
                                     class="form-control-file"
                                     id="file"
                                     ref="thumbnail"
                                     accept=".jpg, .jpeg, .png"
                                     style="padding:5px"
                              /></div>
                            <div style="float:left" class="imgview" :data="item.file_url" v-for="item, index in queryParams.listThumbnailFile">등록된 파일 : {{item.file_originalname}} ({{item.filesizeStr}})
                            </div>
                            <div style="float:left" :data="item.file_url" v-for="item, index in queryParams.listThumbnailFile">
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button @click="delThumbnailFile(item.idx)">삭제</button>
                            </div>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">TAG</label>
                      </td>
                      <td class="" colspan="4">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" type="text" v-model="queryParams.tag"></b-form-input>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1; font-weight:bold">
                        <label class="col-form-label">개요 *</label>
                      </td>
                      <td class="" colspan="4">
                         <vue-ckeditor v-model="queryParams.summary" :config="config" />
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">상세설명</label>
                      </td>
                      <td class="" colspan="4">
                         <vue-ckeditor v-model="queryParams.detaile_content" :config="config" />
                      </td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>
        <!-- 관심 카테고리 설정   -->
        <b-card>
          <div slot="header">
            <strong>▣ 관심 카테고리 설정</strong>
          </div>
          <div class="table-responsive-sm">
            <table id="" aria-busy="false" aria-colcount="4" aria-rowcount="-1" class="table b-table table-striped">
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">카테고리</label>
                </td>
                <td class="" colspan="4">
                  <b-row class="pt-sm-12">
                    <b-col sm="12">
                      <b-button size="sm" class="mx-1"
                                variant="outline-primary"
                                v-for="(categoryItem, idx) in categoryItems"
                                :key="idx"
                                :pressed.sync="categoryItem.state"
                      >
                        {{ categoryItem.item_name }}
                      </b-button>
                    </b-col>
                  </b-row>
                </td>
              </tr>
            </table>
          </div>

        </b-card>
        <!--  상세정보      -->
        <b-card>
          <div slot="header" v-show="optiontap == 'normaltap'">
            <strong v-show="true">▣ 리포트 파일 정보</strong>
          </div>

          <div class="table-responsive-sm" v-show="optiontap == 'normaltap'">
            <table id="__BVID__2714" aria-busy="false" aria-colcount="4" aria-rowcount="-1" class="table b-table table-striped">
              <tbody class="">
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; font-weight:bold">
                  <label class="col-form-label">미리보기 사용 *</label>
                </td>
                <td class="" colspan="4" style="text-align: left;">
                  <label class="col-form-label">
                    <b-form-radio-group v-model="queryParams.preview_yn" @change="changePreviewYn()">
                      <b-form-radio value="Y">사용</b-form-radio>
                      <b-form-radio value="N">사용 안함</b-form-radio>
                    </b-form-radio-group>
                  </label>
                </td>
              </tr>
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1;">
                  <label class="col-form-label">미리보기 설정</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="3">
                      <b-form-input
                        id="basicText"
                        type="text"
                        name="previewStart"
                        v-model="queryParams.preview_start"
                        :disabled="queryParams.preview_yn === 'N'"
                        v-validate="{ required: queryParams.preview_yn === 'Y'}"
                        :class="{'is-invalid': errors.has('previewStart')}"
                        v-numbers-only
                      >
                      </b-form-input>
                    </b-col>
                    <b-col sm="2">
                      page   ~
                    </b-col>
                    <b-col sm="3">
                      <b-form-input
                        id="basicText"
                        type="text"
                        name="previewStart"
                        v-model="queryParams.preview_end"
                        :disabled="queryParams.preview_yn === 'N'"
                        v-validate="{ required: queryParams.preview_yn === 'Y'}"
                        :class="{'is-invalid': errors.has('previewStart')}"
                        v-numbers-only
                      >
                      </b-form-input>
                    </b-col>
                    <b-col sm="2">
                      page
                    </b-col>
                  </b-row>
                  <span v-show="errors.has('previewStart')" :class="{error: errors.has('previewStart')}">미리보기 페이지를 설정해주세요</span>
                </td>
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">페이지 정보</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="10">
                    <b-form-input id="basicText"
                                  type="text"
                                  v-model="queryParams.page_cnt"
                                  v-numbers-only
                    ></b-form-input>
                    </b-col>
                  </b-row>
                </td>

              </tr>
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0;">
                <td class="" style="border-right:1px solid #a4b7c1; background-color:#f1f1f1; font-weight:bold">
                  <label class="col-form-label">보고서 파일 *</label>
                </td>
                <td class="" colspan="4">
                  <b-row class="pt-sm-12">
                    <b-col sm="12">
                      <table style="width:100%">
                        <tr v-if="queryParams.sales_type == 'pay'">
                          <td style="border-top:0px; background:#ffffff; vertical-align:middle; padding:0px; width:145px">
                            보안 PDF 파일 :
                          </td>
                          <td style="border-top:0px; background:#ffffff; padding:0px; width:1000px">
                            <div style="border:1px solid #c2cfd6; border-radius:4px; width:80%">
                              <input type="file"
                                     class="form-control-file"
                                     id="securityFile"
                                     ref="securityFile"
                                     style="padding:5px"
                              /></div>
                            <b-progress :value="progressCounter" :max="100" show-progress animated style="margin-top:5px; display:none" id="securityProgress"></b-progress>
                            <div style="float:left" v-for="item, index in securityFileItem" v-show="!securityFileYn">등록된 파일 : {{item.file_originalname}} ({{item.filesizeStr}})</div>
                          </td>
                          <td style="border-top:0px; background:#ffffff; padding:0 0 0 15px; width:300px">
                            <b-form-input id="basicText"
                                          type="text"
                                          name="securityprice"
                                          style="width:80%; float:left; padding:18px"
                                          v-model="queryParams.security_price"
                                          v-numbers-only
                            >
                            </b-form-input>
                            <div style="float:right; width:20%; float:right"><label class="col-form-label">원</label></div>
                          </td>
                        </tr>
                        <tr v-if="queryParams.sales_type === 'pay'">
                          <td style="border-top:0px; background:#ffffff; vertical-align:middle; padding:5px 0 0 0px; width:145px">
                            일반 PDF 파일 :
                          </td>
                          <td style="border-top:0px; background:#ffffff; padding:5px 0 0 0px; width:1000px">
                            <div style="border:1px solid #c2cfd6; border-radius:4px; width:80%">
                              <input type="file"
                                     class="form-control-file"
                                     id="normalFile"
                                     ref="normalFile"
                                     />
                            </div>
                            <b-progress :value="progressCounter" :max="100" show-progress animated style="margin-top:5px; display:none" id="normalProgress"></b-progress>
                            <div style="float:left" v-for="item, index in normalFileItem" v-show="!normalFileYn">
                              등록된 파일 : <a :href="item.file_url" target="_blank">{{item.file_originalname}} ({{item.filesizeStr}})</a>
                            </div>
                          </td>
                          <td style="border-top:0px; background:#ffffff; padding:5px 0px 0px 15px; width:300px">
                            <b-form-input
                              id="basicText"
                              type="text"
                              name="normal_price"
                              style="width:80%; float:left; padding:18px"
                              v-model="queryParams.normal_price"
                              v-numbers-only
                            >
                            </b-form-input>
                            <div style="float:right; width:20%; float:right"><label class="col-form-label">원</label></div>
                          </td>
                        </tr>
                        <tr>
                        <tr v-if="queryParams.sales_type === 'free'">
                          <td style="border-top:0px; background:#ffffff; vertical-align:middle; padding:5px 0 0 0px; width:145px">
                            무료 PDF 파일 :
                          </td>
                          <td style="border-top:0px; background:#ffffff; padding:5px 0 0 0px; width:1000px">
                            <div style="border:1px solid #c2cfd6; border-radius:4px; width:80%">
                              <input type="file"
                                     class="form-control-file"
                                     id="freeFile"
                                     ref="freeFile"
                              />
                            </div>
                            <b-progress :value="progressCounter" :max="100" show-progress animated style="margin-top:5px; display:none" id="originalProgress"></b-progress>
                            <div style="float:left" v-for="item, index in queryParams.attachmentFileItems" v-show="queryParams.attachmentFileItems.length>0">
                              등록된 파일 : <a :href="item.file_url" target="_blank">{{item.file_originalname}} ({{item.filesizeStr}})</a>
                            </div>
                          </td>
                          <td style="border-top:0px; background:#ffffff; padding:5px 0px 0px 15px; width:300px">
<!--                            <b-form-input id="basicText" type="text" name="originalprice" style="width:80%; float:left; padding:18px" v-model="optDatas.original_price" @keyup="numberFormatOriginal(optDatas.original_price)" @blur="numberFormatOriginal(optDatas.original_price)"></b-form-input>-->
<!--                            <div style="float:right; width:20%; float:right"><label class="col-form-label">원</label></div>-->
                          </td>
                        </tr>
                      </table>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-card>
        <!-- 등록 버튼       -->
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="6">
                  <b-button variant="success"
                            v-if="formtype === 'insert'"
                            v-on:click="insertDrReport()"
                            :disabled="isButtonDisabled"
                            style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px">
                    <h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5>
                  </b-button>
                  <b-button variant="success" v-else v-on:click="updateDrReport()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px">
                    <h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 수정</h5>
                  </b-button>
                </b-col>
                <b-col md="6">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/contents/list'"><i class="fa fa-list-ul"></i> 목록</b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
     </b-row>
  </div>
</template>
<script>
import Vue from 'vue';
import datetimepicker from "daterangepicker/daterangepicker.js";
import reportOptModal from './ReportOptModal';
import draggable from "vuedraggable";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'

import VueCkeditor from 'vue-ckeditor2';

const moment = require("moment");

import VeeValidate from 'vee-validate';
import ReportMenuComponent from "./component/ReportMenuComponent";
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  name:'ContentsForm',
  components: {
    ReportMenuComponent,
    VueCkeditor,
    reportOptModal,
    draggable,
    Multiselect
  },
  data() {
    return {
      progressCounter: 0,
      progressTimer: null,
      opttapCheck:true,
      pkgtapCheck:false,
      formModal:false,
      valueCheck:false,
      reportcode: this.$route.query.dr_code,
      dr_topdeth_code: '',
      dr_unique_code: '',
      dr_filepath_code: '',
      formtype: '',
      freeReportOption: [], // 무료 리포트 목록 조회 => 요약본 다운로드에 필요한 옵션 선택
      ratingOptions: [], // 평가시 적립 포인트 코드 조회 => 평가시 적립 포인트 선택
      shareOptions: [], // 공유시 적립 포인트 코드 조회 => 공유시 적립 포인트 선택
      reportOptions: {
        optItems: [],
        pkgItems: [],
      },
      pageOptions: [5, 10, 30, 50, 100],
      reportPkgOptDatas: {
        pkgOptList: []
      },
      selectAbridgementSample: '',
      ratingPointData: '',
      sharePointData: '',
      queryParams: {
        type_code : '', //주 소메뉴
        sub_type_code : '', //부 소메뉴
        report_name : '',
        sub_report_name : '',
        author : '',
        sales_type: 'free',
        preview_yn: 'N',
        view_yn: 'Y',
        custom_date: moment().format('YYYY-MM-DD'), // 출시일
        ibsn : '',
        sample_comment : '', //표본수
        tag : '',
        summary : '', // 개요
        toc : '', // 목차
        detaile_content : '', //상세설명
        categoryitems:[], // 관심카테고리 설정
        preview_start : 0, //미리보기 시작 페이지
        preview_end : 0, //미리보기 종료 페이지
        page_cnt : 0, //페이지 수

        thumbnailFile : '',
        securityFile : '',
        normalFile : '',
        freeFile : '',

        security_price : 0,
        normal_price : 0,

        reg_date: moment().format('YYYY-MM-DD'),
        r_type : 0,

        bestview_yn: "N",
        // pointminus_period: '1',
        // rating_point_code: '',
        // share_point_code: '',
        // pointminus: 0,
        attachmentFileItems:[],
        // previewFileItems:[],
        listThumbnailFile:[],
//        abridgement_downlink: '', //요약본
        optList : [],
      },
      securityFileYn: false,
      normalFileYn: false,
      originalFileYn: false,
      optDatas: {
        security_originalfile_name: '',
        security_filesizeStr: '',
        normal_originalfile_name: '',
        normal_filesizeStr: '',
        original_originalfile_name: '',
        original_filesizeStr: '',
        security_price: 0,
        normal_price: 0,
        original_price: 0,
      },
      pkgDatas: {normal_price: 0, security_price: 0},
      optList: [],
      pkgList: [],
      // pkgOptList: [],
      securityFileItem: [],
      normalFileItem: [],
      originalFileItem: [],
      optiontap:'normaltap',
      tap_option_type:'POT_1',
      reportSubDepths: [],
      categoryItems: [],
      periodOptions: [],
      optExposureOptions: [
        {text: '비노출',value: 0}
      ],
      pkgExposureOptions: [
        {text: '비노출',value: 0}
      ],
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      enabled: true,
      dragging: false,
      isDragging : false,
      file: '',
      reportmenu : {
        "dr_type_code" : '',
        "type_code" : '',
        "sub_main_type_code" : '',
        "sub_type_code" : '',

      },
      config: {
        toolbar:[
          { name: 'document', items: [ 'Source', 'Preview'] },
          { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
          { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
          '-',
          { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
          { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
          { name: 'links', items: ['Link', 'Unlink'] },
          '/',
          { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
          { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: [ 'Maximize' ] },
          { name: 'about', items: [ 'About' ] }
        ],
        font_names: 'Noto Sans KR/Noto Sans KR,sans-serif;맑은 고딕/Malgun Gothic;굴림/Gulim;돋움/Dotum;바탕/Batang;궁서/Gungsuh;',
        filebrowserImageUploadUrl:'backend/ftpserver/ckeditImageUpload',
        uploadUrl: 'backend/ftpserver/ckeditImageUpload?command=QuickUpload&type=Files&responseType=json',
        height: 300,
        versionCheck: false,
        extraPlugins: 'tableresize'
      },
      isButtonDisabled: false,
    }
  },
  watch: {
    'queryParams.attachmentFileItems' () {

    },
    'queryParams.previewFileItems' () {

    },
  },
  created() {
    if(this.$route.query.dr_code){
      this.formtype = 'update';
    }else {
      this.formtype = 'insert';
    }
  },
  mounted: function() {
    const token = sessionStorage.getItem("myToken");
    const self = this;

    this.reportcode = this.$session.get('reportDrcode');
    this.dr_topdeth_code = this.$session.get('dr_topdeth_code');
    this.dr_unique_code = this.$session.get('dr_unique_code');
    // this.dr_filepath_code = this.dr_unique_code.toLowerCase();

    if(self.formtype === 'update'){
      //this.init()
      self.$http.get('/api/select/drReportData?access_token=' + token + '&reportcode=' + self.reportcode)
        .then((result) => {
          console.log(this.queryParams);
          self.queryParams = result.data;

          this.reportmenu.dr_type_code = result.data.dr_type_code //주 대분류
          this.reportmenu.type_code = result.data.type_code //주 소분류

          this.reportmenu.sub_main_type_code = result.data.sub_main_type_code //부 대분류
          this.reportmenu.sub_type_code = result.data.sub_type_code //부 소분류


          self.optiontap = 'normaltap';
          self.tap_option_type = 'POT_1';

          setTimeout(function(){
            console.log(self.queryParams.categoryitems);
            self.categoryItems.forEach(function (t_el, t_idx, t_arr){
              self.queryParams.categoryitems.forEach(function (s_el, s_idx, s_arr){
                if(t_el.item_code == s_el.cate_code){
                  t_el.state = true;
                }
              });
            });
          }, 250);

          //유로 보고서 첨부파일
          this.getDrOptList(self.reportcode);
        })
    }else {
      this.formtype = 'insert';
    }

    // self.drFreeReportOption();
    // self.getPointOptions();

    $(function() {
      $('input[name="daterange"]').daterangepicker({
        opens: 'left',
        singleDatePicker: true,
        "locale": self.calendarLocale,
        "endDate": moment().format('YYYY-MM-DD'),
        "startDate": moment().format('YYYY-MM-DD')
      }, function(start, end, label) {
        self.startDate = start.format('YYYY-MM-DD');
        self.queryParams.custom_date = self.startDate;
        self.endDate = end.format('YYYY-MM-DD');
      });
    });

    // ### 코드 정보 불러오기 ###
    // 신규코드를 DB테이블에 저장
    //
    // 최초작성 : 2016.05.31
    // 파라미터 : parentCode
    //  - unit(JSON 형태의 코드 아이템 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    self.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=INTEREST_FIELD_CODE')
    .then((result) => {
      var categoryDatas = result.data;
      categoryDatas.forEach(function (el, idx, arr){
        if(self.formtype == 'insert'){
          if(idx == 0){
            el.state = true;
          }else{
            el.state = false;
          }
        }else{
          el.state = false;
        }
      });
      this.categoryItems = categoryDatas;
    })
    //this.selectItemCodeList(self.dr_topdeth_code,3);


  },
  methods: {
    customLabel ({ desc, img }) {
      return `${desc} - ${img}`
    },
    ratingLabel ({ name, num }) {
      return `${name} - ${Number(num).toLocaleString()+'점'}`
    },
    shareLabel ({ name, num }) {
      return `${name} - ${Number(num).toLocaleString()+'점'}`
    },
    // 메소드명 : getDrReportData(val)
    // ### 리포트 데이터 갱신 ###
    // 메소드 저장후 데이터 갱신용으로 사용
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - val(해당 필드의 value 값을 가져옴)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.06.10  황경현   최초작성
    // *************************
    getDrReportData(reportCode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/drReportData?access_token=' + token + '&reportcode=' + reportCode)
      .then((result) => {
        self.queryParams = result.data;
        self.queryParams.pointminus = Number(self.queryParams.pointminus).toLocaleString();
        setTimeout(function(){
          self.categoryItems.forEach(function (t_el, t_idx, t_arr){
            self.queryParams.categoryitems.forEach(function (s_el, s_idx, s_arr){
              if(t_el.item_code == s_el.cate_code){
                t_el.state = true;
              }
            });
          });
        }, 250);
        self.getDrOptList(reportCode);
      })
    },
    // 메소드명 : drFreeReportOption()
    // ### 무료 리포트 목록을 조회한다 ###
    // 무료 리포트 목록을 조회하여 해당 유료 컨텐츠의 요약본 다운로드에 필요한 링크 저장
    //
    // 최초작성 : 2016.07.21
    // 파라미터 :
    //  - dr_deth_code(그룹코드 값)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.21  황경현   최초작성
    // *************************
    drFreeReportOption() {
      var self = this;
      self.freeReportOption = [];
      self.queryParams.dr_deth_code = self.dr_topdeth_code;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/drFreeReportOption?access_token=' + token, data, null)
        .then((result) => {
          var freeROption = result.data;

          freeROption.forEach(function (el, idx, arr){
            var items = {
              title: el.report_name,
              desc: el.report_file_name,
              img: el.thumbnail_url,
              file: el.report_file_url,
            };
            self.freeReportOption.push(items);
          });

          setTimeout(function(){
            if(self.formtype == 'update'){
              self.freeReportOption.forEach(function (el, idx, arr){
                if(el.file == self.queryParams.abridgement_downlink){
                  self.selectAbridgementSample = el;
                }
              });
            }
          }, 100);

        })
    },
    // 메소드명 : drFreeReportOption()
    // ### 무료 리포트 목록을 조회한다 ###
    // 무료 리포트 목록을 조회하여 해당 유료 컨텐츠의 요약본 다운로드에 필요한 링크 저장
    //
    // 최초작성 : 2016.07.21
    // 파라미터 :
    //  - dr_deth_code(그룹코드 값)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.21  황경현   최초작성
    // *************************
    getPointOptions() {
      var self = this;
      self.ratingOptions = [];
      self.shareOptions = [];
      var token = sessionStorage.getItem("myToken");
      self.$http.post('/api/select/drFreePointOptions?access_token=' + token, null)
        .then((result) => {
          var reportDatas = result.data;
          var pointROption = reportDatas.reportPointOptions;
          pointROption.forEach(function (el, idx, arr){
            var items = {
              name: el.point_name,
              code: el.point_code,
              num: el.point_num,
            };
            self.ratingOptions.push(items);
            self.shareOptions.push(items);
          });

          setTimeout(function(){
            if(self.formtype == 'update'){
              self.ratingOptions.forEach(function (el, idx, arr){
                if(el.code == self.queryParams.rating_point_code){
                  self.ratingPointData = el;
                }
              });
              self.shareOptions.forEach(function (el, idx, arr){
                if(el.code == self.queryParams.share_point_code){
                  self.sharePointData = el;
                }
              });
            }else{
              self.ratingOptions.forEach(function (el, idx, arr){
                if(el.code == reportDatas.rating_point_code){
                  self.ratingPointData = el;
                  self.queryParams.rating_point_code = el.code;
                }
              });
              self.shareOptions.forEach(function (el, idx, arr){
                if(el.code == reportDatas.share_point_code){
                  self.sharePointData = el;
                  self.queryParams.share_point_code = el.code;
                }
              });

              console.log(self.ratingPointData);
            }
          }, 100);
        })
    },
    // 메소드명 : numberFormat(val)
    // ### 숫자입력함수 ###
    // 신규코드를 DB테이블에 저장
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - val(해당 필드의 value 값을 가져옴)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    numberFormat(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 7){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 7){ val = val.substring(0, val.length-1); }
				this.queryParams.pointminus = "0";
      }else{
        this.queryParams.pointminus = Number(val).toLocaleString();
      }
    },
    numberFormatSecurity(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.queryParams.security_price = "0";
      }else{
        this.queryParams.security_price = Number(val).toLocaleString();
      }
    },
    numberFormatNormal(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.queryParams.normal_price = "0";
      }else{
        this.queryParams.normal_price = Number(val).toLocaleString();
      }
    },
    numberFormatOriginal(val) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.optDatas.original_price = "0";
      }else{
        this.optDatas.original_price = Number(val).toLocaleString();
      }
    },
    numberFormatPkg(val, targetId) {
      var reg = /[^0-9]/gi;
      if(val.length > 12){ val = val.substring(0, val.length-1); }
      val = $.trim(val.replace(/,/g, ''));
      if (reg.test(val)) {
        if(val.length > 12){ val = val.substring(0, val.length-1); }
				this.pkgDatas[targetId] = "0";
      }else{
        this.pkgDatas[targetId] = Number(val).toLocaleString();
      }
    },
    // 메소드명 : onFileChange(parentCode, depth)
    // ### 단일 파일다운로드 ###
    // 단일로 파일을 넘겨 받는다.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - e(해당 함수 이벤트가 일어 날시에 가져온다)
    //  - depth(대분류,소분류 구분)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.queryParams.files = files;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(this.queryParams));

      var data = new FormData();
      data.append('objs', param);

      this.$http.post('/common/optFtpFileUpload?access_token=' + token, data, null)
        .then((result) => {
          this.items = result.data;
        })
    },
    removeListFile(e) {
      console.log(e);
      var fileLists = [];
      var className = e.target.parentNode.parentNode.parentNode.parentNode.classList[1];
      var targetFileUrl = e.target.parentNode.parentNode.parentNode.children[1].lastChild.innerText;
      if(className == "attachment"){
        fileLists = this.queryParams.attachmentFileItems;
      }else if(className == "preview"){
        fileLists = this.queryParams.previewFileItems;
      }

      fileLists.forEach(function (el, idx, arr){
        if(el.file_url == $.trim(targetFileUrl)){
          fileLists.splice(idx, 1);
        }
      });
      fileLists.forEach(function (el, idx, arr){
        el.file_sequence = (idx+1);
      });

      if(className == "attachment"){
        this.queryParams.attachmentFileItems = fileLists;
      }else if(className == "preview"){
        this.queryParams.previewFileItems = fileLists;
      }
    },
    inputChanged(value) {
      console.log(value);
      this.activeNames = value;
    },
    // 메소드명 : getComponentData()
    // ### 드랍앤드래그 리스트 이동 ###
    // 드랍앤드래그 이동시 이벤트 발생.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 : 없음
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
          input: this.inputChanged
        },
        attrs:{
          wrap: true
        },
        props: {
          value: this.activeNames
        }
      };
    },
    // 메소드명 : insertDrReport()
    // ### 보고서 최초 저장 ###
    // 보고서 최초 저장
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    insertDrReport() {
      var self = this;
      self.$validator.validateAll().then(success => {
          if (success) {
            const data = new FormData();

            var token = sessionStorage.getItem("myToken");
            var categoryParams = [];

            self.queryParams.reg_id = self.$session.get('userId');

            self.categoryItems.forEach(function (el, idx, arr){
              var categoryData = {
                cate_code: el.item_code
              }
              if(el.state){
                categoryParams.push(categoryData);
              }
            });
            self.queryParams.categoryitems = categoryParams;

            //썸네일
            if(this.$refs.thumbnail.files.length > 0){
              data.append('thumbnailFile', this.$refs.thumbnail.files[0])
            }

            if(this.queryParams.sales_type === 'pay'){
              //보안 유료 파일
              if(this.$refs.securityFile.files.length > 0){
                data.append('securityFile', this.$refs.securityFile.files[0])
              }

              //일반 유료 파일
              if(this.$refs.normalFile.files.length > 0){
                data.append('normalFile', this.$refs.normalFile.files[0])
              }
            }else{
              //무료 파일
              if(this.$refs.freeFile.files.length > 0){
                data.append('freeFile', this.$refs.freeFile.files[0])
              }
            }

            const param = encodeURI(JSON.stringify(this.queryParams));
            data.append('reportObj', param);
            if (!this.isButtonDisabled) {
              this.isButtonDisabled = true;

              self.$http.post('/api/insert/drReport?access_token='+token, data, null)
                .then((result) => {
                  if(result.data === 'error'){
                    this.isButtonDisabled = false
                    swal.fire({
                      type: 'success',
                      title: '보고서 등록이 실패했습니다.',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function() {
                      window.location = "#/contents/list";
                    });
                  }else {
                    swal.fire({
                      type: 'success',
                      title: '보고서가 등록되었습니다.',
                      showConfirmButton: false,
                      timer: 1500
                    }).then(function() {
                      window.location = "#/contents/list";
                    });
                  }
                }).catch(error => {
                this.isButtonDisabled = false
                swal.fire({
                  type: 'success',
                  title: '보고서 등록이 실패했습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                  window.location = "#/contents/list";
                });

              })
            }

          }
      })
    },
    // 메소드명 : updateDrReport()
    // ### 보고서 수정 ###
    // 보고서를 각 데이터를 수정한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    updateDrReport() {
      this.$validator.validateAll().then(success => {
          if (success) {

            //패키지 형식 유료 보고서 수정 불가
            const validReportCodes = [
              'DMCSRP20190013',
              'DMCSRP20200012',
              'DMCSRP20200061',
              'DMCSRP20210038'
            ];

            if(validReportCodes.includes(this.reportcode)){
              swal.fire({
                title: '',
                html: "해당 보고서는 수정이 불가 합니다. 관리자에게 문의 바랍니다.",
                type: 'warning',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
              })
              return;
            }

            if(this.queryParams.sales_type === 'free'){
              //무료
              if(this.queryParams.preview_yn === 'Y'){
                if(!this.hasPdfFile(this.queryParams.attachmentFileItems)){
                  swal.fire({
                    title: '',
                    html: "PDF 파일만 미리보기를 만들 수 있습니다.",
                    type: 'warning',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                  })
                  this.queryParams.preview_yn = 'N'
                  return;
                }
              }
            }else{
              //유료
            }

            const token = sessionStorage.getItem("myToken");
            const self = this;

            var data = new FormData();

            var categoryParams = [];
            self.queryParams.dr_code = self.reportcode;
            self.queryParams.reg_id = self.$session.get('userId');
            self.queryParams.optList = this.optList

            self.categoryItems.forEach(function (el, idx, arr){
              var categoryData = {
                cate_code: el.item_code
              }
              if(el.state){
                categoryParams.push(categoryData);
              }
            });

            //카테고리
            self.queryParams.categoryitems = categoryParams;


            //썸네일
            if(this.$refs.thumbnail.files.length > 0){
              data.append('thumbnailFile', this.$refs.thumbnail.files[0])
            }

            //리포트 파일
            if(this.queryParams.sales_type === 'pay'){
              //보안 유료 파일
              if(this.$refs.securityFile.files.length > 0){
                data.append('securityFile', this.$refs.securityFile.files[0])
              }

              //일반 유료 파일
              if(this.$refs.normalFile.files.length > 0){
                data.append('normalFile', this.$refs.normalFile.files[0])
              }
            }else{
              //무료 파일
              if(this.$refs.freeFile.files.length > 0){
                data.append('freeFile', this.$refs.freeFile.files[0])
              }
            }

            var param = encodeURI(JSON.stringify(self.queryParams));

            data.append('reportObj', param);

            console.log(self.queryParams);
            self.$http.post('/api/update/drReport?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '보고서를 수정하였습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                    window.location = "#/contents/list"
                });
            })
          }
      })
    },
    // 메소드명 : addDrOpt()
    // ### 옵션을 최초 저장 ###
    // 옵션을 최초 데이터를 DB에 저장한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    addDrOpt(inDatas) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      var parmDatas = inDatas;

      if(parmDatas.name == undefined || parmDatas.name == ""){
        self.valueCheck = true;
      }else{
        self.valueCheck = false;
      }

      if(!self.valueCheck){
        parmDatas.reg_id = self.$session.get('userId');
        parmDatas.dr_code = self.reportcode;
        parmDatas.type = self.tap_option_type;

        if(parmDatas.security_price != 0){
            parmDatas.security_price = $.trim(parmDatas.security_price.replace(/,/g, ''));
        }
        if(parmDatas.normal_price != 0){
            parmDatas.normal_price = $.trim(parmDatas.normal_price.replace(/,/g, ''));
        }
        if(parmDatas.type == "POT_1"){
          if(parmDatas.original_price != 0){
              parmDatas.original_price = $.trim(parmDatas.original_price.replace(/,/g, ''));
          }
        }

        var param = encodeURI(JSON.stringify(parmDatas));

        var data = new FormData();
        data.append('optObj', param);

        if(self.isNew){
          self.$http.post('/api/insert/drReportOpt?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '옵션을 저장하였습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.optDatas = {
                  security_price: 0,
                  normal_price: 0,
                  original_price: 0
                };
                self.pkgDatas = {price: 0};

                self.securityFileItem = [];
                $("#securityfile").val("");
                self.normalFileItem = [];
                $("#normalfile").val("");
                self.originalFileItem = [];
                $("#originalfile").val("");

                $("#optfile").val("");
                self.isNew = true;
                self.getDrOptList(self.reportcode);
              });
          })
        }else{
          self.$http.post('/api/update/drReportOpt?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '옵션이 수정되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.optDatas = {security_price: 0, normal_price: 0, original_price: 0};
                self.pkgDatas = {security_price: 0, normal_price: 0};

                self.securityFileItem = [];
                $("#securityfile").val("");
                self.normalFileItem = [];
                $("#normalfile").val("");
                self.originalFileItem = [];
                $("#originalfile").val("");

                self.isNew = true;
                self.getDrOptList(self.reportcode);
              });
          })
        }
      }
    },
    // 메소드명 : addDrOpt()
    // ### 옵션을 최초 저장 ###
    // 옵션을 최초 데이터를 DB에 저장한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    addDrPkgOpt() {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.reportPkgOptDatas.pkgOptList = [];
      self.reportOptions.pkgItems.forEach(function (el, idx, arr){
        var pkgOptData = {
          pkg_code: self.reportOptions.pkg_code,
          opt_code: el.opt_code
        }
        self.reportPkgOptDatas.pkgOptList.push(pkgOptData);
      });

      self.reportPkgOptDatas.dr_code = self.reportcode;
      self.reportPkgOptDatas.dr_pkg_code = self.reportOptions.pkg_code;
      var param = encodeURI(JSON.stringify(self.reportPkgOptDatas));
      var data = new FormData();
      data.append('reportObj', param);

      self.$http.post('/api/insert/drReportPkgOpt?access_token='+token, data, null)
        .then((result) => {
          self.reportPkgOptDatas.pkgOptList = [];
          self.reportOptions.optItems = [];
          self.reportOptions.pkgItems = [];
          self.formModal = false;
          self.getDrOptList(self.reportcode);

          // swal.fire({
          //   type: 'success',
          //   title: '패키지옵션을 저장하였습니다.',
          //   showConfirmButton: false,
          //   timer: 1000
          // }).then(function() {
            // self.optDatas = {};
            // self.pkgDatas = {};
            // self.optionFileItem = [];
            // $("#optfile").val("");
            // self.isNew = true;
            // self.getDrOptList(self.$route.params.reportcode);
          // });
      })
    },
    // 메소드명 : editOpt(row)
    // ### 옵션을 수정 ###
    // 옵션을 각데이터 마다 수정한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - row : 각row의 데이터
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    editOpt(row){
      var self = this;
      $("#securityfile").val("");
      $("#normalfile").val("");
      $("#originalfile").val("");
      self.isNew = false;
      self.optExposureOptions = [
        {text: '비노출',value: 0}
      ];
      self.optList.forEach(function (el, idx, arr){
        var options = {
          text: (idx+1),
          value: (idx+1)
        }
        self.optExposureOptions.push(options);
      });
      row.old_exposure = row.exposure;
      self.optDatas = row;

      self.securityFileItem = [{
        file_originalname: row.security_originalfile_name,
        filesizeStr: row.security_filesizeStr
      }];
      self.normalFileItem = [{
        file_originalname: row.normal_originalfile_name,
        filesizeStr: row.normal_filesizeStr
      }];
      self.originalFileItem = [{
        file_originalname: row.original_originalfile_name,
        filesizeStr: row.original_filesizeStr
      }];
    },
    deleteOpt(optdata){
      var self = this;

      swal.fire({
        title: '보고서 옵션 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "<b>보고서의 옵션 저장된 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?</b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          var token = sessionStorage.getItem("myToken");
          self.reportOptions.dr_code = self.reportcode;
          self.reportOptions.opt_code = optdata.opt_code;
          var param = encodeURI(JSON.stringify(self.reportOptions));

          var data = new FormData();
          data.append('reportOptObj', param);

          self.$http.post('/api/delete/drReportOpt?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '옵션이 정상적으로 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.optDatas = {price: 0};
                self.pkgDatas = {price: 0};

                self.securityFileItem = [];
                $("#securityfile").val("");
                self.normalFileItem = [];
                $("#normalfile").val("");
                self.originalFileItem = [];
                $("#originalfile").val("");

                self.isNew = true;
                self.getDrOptList(self.reportcode);
              });
          })
        }else{
          // cansel
        }
      })
    },
    // 메소드명 : editPkg(row)
    // ### 패키지 수정 ###
    // 패키지를 각데이터 마다 수정한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - row : 각row의 데이터
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    editPkg(row){
      var self = this;
      self.isNew = false;
      self.pkgExposureOptions = [
        {text: '비노출',value: 0}
      ];
      self.pkgList.forEach(function (el, idx, arr){
        var pkoptions = {
          text: (idx+1),
          value: (idx+1)
        }
        self.pkgExposureOptions.push(pkoptions);
      });
      row.old_exposure = row.exposure;
      self.pkgDatas = row;
    },
    // 메소드명 : deletePkg(row)
    // ### 패키지 수정 ###
    // 구매여부를 체크후 패키지 삭제
    //
    // 최초작성 : 2020.05.11
    // 파라미터 :
    //  - row : 각row의 데이터
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2020.06.11  황경현   최초작성
    // *************************
    deletePkg(row){
      var self = this;
      var token = sessionStorage.getItem("myToken");
      self.newPkgClear();
      self.reportOptions.dr_code = self.reportcode;
      self.reportOptions.pkg_code = row.pkg_code;
      var param = encodeURI(JSON.stringify(self.reportOptions));
      var data = new FormData();
      data.append('reportPkgObj', param);
      self.$http.post('/api/select/drOptOrderCheck?access_token='+token, data, null)
        .then((result) => {

      })
    },
    newOptClear(){
      this.isNew = true;
      this.optDatas = {
        exposure: (this.optExposureOptions.length-1),
        security_price: 0,
        normal_price: 0,
        original_price: 0
      };
      this.securityFileItem = [];
      this.normalFileItem = [];
      this.originalFileItem = [];

      this.getDrOptList(this.reportcode);
  	},
    newPkgClear(){
      this.isNew = true;
      this.pkgDatas = {
        exposure: (this.pkgExposureOptions.length-1),
        price: 0,
        security_price: 0,
        normal_price: 0
      };
      this.getDrOptList(this.reportcode);
  	},
    openOptPkg(row){
      var self = this;
      self.newPkgClear();
      self.reportOptions.optItems = self.$_.clone(self.optList);
      self.reportOptions.pkgItems = [];
      self.reportOptions.pkg_code = row.opt_code;
      self.formModal = true;
      self.getDrPkgOptList(self.reportOptions.pkg_code);
    },

    // addOptPkg(){
    //   this.formModal = true;
    // },
    getDrOptList (reportcode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.optExposureOptions = [
        {text: '비노출',value: 0}
      ],
      self.pkgExposureOptions = [
        {text: '비노출',value: 0}
      ],
      self.$http.get('/api/select/drReportOptList?access_token=' + token + '&reportcode=' + reportcode)
      .then((result) => {
        console.log(result.data);
        self.optList = result.data.optList;
        self.pkgList = result.data.pkgList;

        if(self.optList.length > 0){
          if(self.optList.length > 1){
            self.optList.forEach(function (el, idx, arr){
              var options = {
                text: (idx+1),
                value: (idx+1)
              }
              el.security_price = Number(el.security_price).toLocaleString();
              el.normal_price = Number(el.normal_price).toLocaleString();
              el.original_price = Number(el.original_price).toLocaleString();
              self.optExposureOptions.push(options);
            });
          }{
            this.queryParams.security_price = this.optList[0].security_price
            this.queryParams.normal_price = this.optList[0].normal_price

            this.securityFileItem = [{
              file_originalname: this.optList[0].security_originalfile_name,
              filesizeStr: this.optList[0].security_filesizeStr
            }];

            this.normalFileItem = [{
              file_originalname: this.optList[0].normal_originalfile_name,
              filesizeStr: this.optList[0].normal_filesizeStr,
              file_url : this.optList[0].normal_file_url
            }];
          }

        }
        self.optExposureOptions.push({text: (self.optList.length+1),value: (self.optList.length+1)});

        console.log(self.pkgList);
        if(self.pkgList.length > 0){
          self.pkgList.forEach(function (el, idx, arr){
            var pkoptions = {
              text: (idx+1),
              value: (idx+1)
            }
            el.security_price = Number(el.security_price).toLocaleString();
            el.normal_price = Number(el.normal_price).toLocaleString();
            self.pkgExposureOptions.push(pkoptions);
          });
        }
        self.pkgExposureOptions.push({text: (self.pkgList.length+1),value: (self.pkgList.length+1)});

        self.optDatas.exposure = (self.optExposureOptions.length-1);
        self.pkgDatas.exposure = (self.pkgExposureOptions.length-1);
      })
    },
    getDrPkgOptList (pkgcode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.reportOptions.dr_code = self.reportcode;
      self.reportOptions.pkg_code = pkgcode;
      var param = encodeURI(JSON.stringify(self.reportOptions));

      var data = new FormData();
      data.append('reportPkgObj', param);

      self.$http.post('/api/select/drReportPkgOptList?access_token=' + token, data, null)
      .then((result) => {
        console.log(result.data);
        self.reportPkgOptDatas = result.data;

        console.log(self.reportPkgOptDatas.pkgOptList);
        console.log(self.reportOptions.optItems);

        self.reportPkgOptDatas.pkgOptList.forEach(function (t_el, t_idx, t_arr){
          self.reportOptions.optItems.forEach(function (s_el, s_idx, s_arr){
            if(t_el.opt_code == s_el.opt_code){
              self.reportOptions.pkgItems.push(s_el);
              self.reportOptions.optItems.splice(s_idx, 1);
            }
          });
        });
      })
    },
    securityFileYnCheck() {
      var self = this;
      if(!self.securityFileYn){
        if(self.securityFileItem.length > 0){
          swal.fire({
            title: '옵션 보안 파일!',
            // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
            html: "저장된 보안 파일이 있습니다.</br>삭제 하시겠습니까?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          }).then((swalResult) => {
            if (swalResult.value) {
              $("#securityfile").val("");
              self.securityFileItem = [];
              self.optDatas.security_originalfile_name = "";
              self.optDatas.security_file_name = "";
              self.optDatas.security_file_path = "";
              self.optDatas.security_file_url = "";
              self.optDatas.security_file_size = 0;
              self.optDatas.security_filesizeStr = "";
            }else{
              self.securityFileYn = false;
            }
          })
        }else{
          $("#securityfile").val("");
          self.securityFileItem = [];
          self.optDatas.security_originalfile_name = "";
          self.optDatas.security_file_name = "";
          self.optDatas.security_file_path = "";
          self.optDatas.security_file_url = "";
          self.optDatas.security_file_size = 0;
          self.optDatas.security_filesizeStr = "";
        }
      }
    },
    normalFileYnCheck() {
      var self = this;
      if(!self.normalFileYn){
        if(self.normalFileItem.length > 0){
          swal.fire({
            title: '옵션 일반 파일!',
            // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
            html: "저장된 일반 파일이 있습니다.</br>삭제 하시겠습니까?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          }).then((swalResult) => {
            if (swalResult.value) {
              $("#normalfile").val("");
              self.normalFileItem = [];
              self.optDatas.normal_originalfile_name = "";
              self.optDatas.normal_file_name = "";
              self.optDatas.normal_file_path = "";
              self.optDatas.normal_file_url = "";
              self.optDatas.normal_file_size = 0;
              self.optDatas.normal_filesizeStr = "";
            }else{
              self.normalFileYn = false;
            }
          })
        }else{
          $("#optfile").val("");
          self.normalFileItem = [];
          self.optDatas.normal_originalfile_name = "";
          self.optDatas.normal_file_name = "";
          self.optDatas.normal_file_path = "";
          self.optDatas.normal_file_url = "";
          self.optDatas.normal_file_size = 0;
          self.optDatas.normal_filesizeStr = "";
        }
      }
    },
    originalFileYnCheck() {
      var self = this;
      if(!self.originalFileYn){
        if(self.originalFileItem.length > 0){
          swal.fire({
            title: '옵션 원본 파일!',
            // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
            html: "저장된 원본 파일이 있습니다.</br>삭제 하시겠습니까?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'OK'
          }).then((swalResult) => {
            if (swalResult.value) {
              $("#originalfile").val("");
              self.originalFileItem = [];
              self.optDatas.original_originalfile_name = "";
              self.optDatas.original_file_name = "";
              self.optDatas.original_file_path = "";
              self.optDatas.original_file_url = "";
              self.optDatas.original_file_size = 0;
              self.optDatas.original_filesizeStr = "";
            }else{
              self.originalFileYn = false;
            }
          })
        }else{
          $("#originalfile").val("");
          self.originalFileItem = [];
          self.optDatas.original_originalfile_name = "";
          self.optDatas.original_file_name = "";
          self.optDatas.original_file_path = "";
          self.optDatas.original_file_url = "";
          self.optDatas.original_file_size = 0;
          self.optDatas.original_filesizeStr = "";
        }
      }
    },
    optPkgCheck(event,check){
      if(!check){
        this.opttapCheck = !this.opttapCheck;
        this.pkgtapCheck = !this.pkgtapCheck;
      }else{
        event.target.checked = true;
      }
    },
    reportAttachmentFileCheck(){
      var self = this;
      // console.log(self.$refs.dropAttachmentFile.dropzone.options.acceptedFiles = );
      if(self.queryParams.type_code == "RPT_TYPE_1_2"){
        self.$refs.dropAttachmentFile.dropzone.options.acceptedFiles = ".pdf,.jpg,.jpeg,.png";
      }else{
        self.$refs.dropAttachmentFile.dropzone.options.acceptedFiles = ".pdf";
      }
      console.log(self.$refs.dropAttachmentFile.dropzone.options.acceptedFiles);
    },
    /**
    * 이미지 파일 업로드
    */
    uploadSummernoteImageFile(file, editor) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var data = new FormData();
      data.append("file", file);

      self.$http.post('/ftpserver/editorImageUpload?access_token='+token, data, null)
      .then((result) => {
        $(editor).summernote('insertImage', result.data);
      })
    },
    setMenuCode(menuType , menuCode){
      if('main' === menuType){
        this.queryParams.type_code = menuCode
      }else{
        this.queryParams.sub_type_code = menuCode
      }
    },
    changePreviewYn(){
      if(this.queryParams.preview_yn === 'Y'){
        //사용안함
        this.queryParams.preview_start = 0
        this.queryParams.preview_end = 0
      }else {
        //사용함
        this.queryParams.preview_start = ''
        this.queryParams.preview_end = ''
      }
    },
    changeSalesType(){
      if(this.queryParams.sales_type === 'free'){
        //유료
        this.queryParams.security_price = ''
        this.queryParams.normal_price = ''
      }else{
        //무료
        this.queryParams.security_price = 0
        this.queryParams.normal_price = 0
      }
    },
    hasPdfFile(fileList){
      //pdf 포함시 true 반환
        return fileList.some(function(filename) {
          console.log(filename)
        let extension = filename.file_originalname.split('.').pop();
        return extension === 'pdf';
      });
    },
    delThumbnailFile(idx){

      //썸네일 이미지 삭제

      if (confirm("썸네일 이미지를 삭제 하겠습니까?")) {

        let token = sessionStorage.getItem("myToken");
        let data = new FormData();
        data.append('idx', idx);

        this.$http.post('/api/delete/thumbnailFile?access_token=' + token, data, null)
          .then((result) => {
            if(result.data === 1){
              this.queryParams.listThumbnailFile = [];
            } else {
              swal.fire({
                type: 'error',
                title: '썸네일 이미지 삭제를 실패했습니다. 관리자에게 문의하세요',
                showConfirmButton: false,
                timer: 2000
              })
            }
          })
      }

    }
  }
}

$(document).ready(function(){
	var xOffset = 50;
  var yOffset = 10;
  $(document).on("mouseover",".imgview",function(e){ //마우스 오버시
      $("body").append("<p id='preview'><img src='"+ $(this).attr("data") +"' /></p>"); //보여줄 이미지를 선언
      $("#preview")
          .css("position","absolute")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px")
          .fadeIn("fast"); //미리보기 화면 설정 셋팅
  });
  $(document).on("mousemove",".imgview",function(e){ //마우스 이동시
      $("#preview")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px");
  });
  $(document).on("mouseout",".imgview",function(){ //마우스 아웃시
      $("#preview").remove();
  });
});
</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}


.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
<style src="daterangepicker/daterangepicker.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/contents/ContentsForm.vue